<mui-form-field
  #muiFormField
  [label]="label"
  [labelFor]="inputId"
  [required]="required">
  <input
    #input
    type="text"
    autocomplete="off"
    [id]="inputId"
    [name]="name"
    [disabled]="disabled"
    [placeholder]="placeholder"
    [class.has--error]="hasError"
    (focus)="onInputFocus()"
    (blur)="onInputBlur($event)"
    (input)="onInputType($event)"
    (change)="onInputChange($event)"
    muiInputBase
    [imask]="_maskOptions"
    (complete)="updateModel($event, true)"
    [ngbPopover]="popoverContent"
    [animation]="animation"
    [placement]="['bottom', 'auto']"
    [disablePopover]="disabled"
    triggers="manual"
    popoverClass="mui-popover mui-datepicker__popover"/>
  <div
    *ngIf="_inputElement?.nativeElement?.value && !disabled && muiFormField.isControlValid" (click)="clear()"
    [attr.aria-label]="(translations$ | async)?.clearButton ?? 'Clear'"
    class="mui-input__trailing"
    role="button">
    <i mui-icon name="times" font="fa" aria-hidden="true"></i>
  </div>
  <ng-content select="mui-form-field-hint"></ng-content>
  <ng-content select="mui-form-field-error"></ng-content>
</mui-form-field>

<ng-template #popoverContent>
  <ngb-datepicker
    #ngbDatepicker
    muiEnter
    [id]="datepickerId"
    (enter)="setDatepicker(ngbDatepicker)"
    (exit)="setDatepicker(null)"
    (click)="$event.preventDefault()"
    [ngModel]="_model"
    (dateSelect)="onDateSelect($event)"
    [dayTemplate]="dayTemplate"
    [displayMonths]="_displayMonths"
    [showWeekNumbers]="_showWeekNumbers"
    [minDate]="minDate ? iso8601StringToNgbDate(minDate) : null"
    [maxDate]="maxDate ? iso8601StringToNgbDate(maxDate) : null">
  </ngb-datepicker>

  <ng-template #dayTemplate let-date let-currentMonth="currentMonth" let-focused="focused">
    <div
      tabindex="0"
      class="mui-datepicker__day"
      [attr.aria-selected]="isSelectedDate(date)"
      [class.selected]="isSelectedDate(date)"
      [class.not-in-month]="date.month !== currentMonth"
      [class.focused]="focused">
      {{ date.day }}
    </div>
  </ng-template>
</ng-template>
